/**
 * Aico product card - swatch slider, swatch select, add to cart
 * Visible swatches: 3 desktop / 2 mobile; arrows show only on overflow
 */
(function () {
  'use strict';

  var mqMobile = window.matchMedia('(max-width: 768px)');

  function metrics(wrapper) {
    var track = wrapper.querySelector('.aico-pc__variants-track');
    var viewport = wrapper.querySelector('.aico-pc__variants-viewport');
    if (!track || !viewport) return null;
    var swatches = track.querySelectorAll('.aico-pc__swatch');
    if (!swatches.length) return null;
    var width = swatches[0].getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var step = width + gap;
    var visible = step > 0 ? Math.max(1, Math.round((viewport.clientWidth + gap) / step)) : 1;
    return { track: track, count: swatches.length, width: width, gap: gap, visible: visible };
  }

  function updateSlider(wrapper) {
    var prevBtn = wrapper.querySelector('.aico-pc__variants-previous-btn');
    var nextBtn = wrapper.querySelector('.aico-pc__variants-next-btn');
    var m = metrics(wrapper);
    if (!m) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
      return;
    }
    var maxIndex = Math.max(0, m.count - m.visible);
    var idx = parseInt(m.track.dataset.index || '0', 10);
    if (idx > maxIndex) idx = maxIndex;
    m.track.dataset.index = String(idx);
    m.track.style.transform = 'translateX(' + -idx * (m.width + m.gap) + 'px)';
    var overflow = m.count > m.visible;
    if (prevBtn) prevBtn.hidden = !overflow || idx <= 0;
    if (nextBtn) nextBtn.hidden = !overflow || idx >= maxIndex;
  }

  function shift(wrapper, dir) {
    var m = metrics(wrapper);
    if (!m || m.count <= m.visible) return;
    var maxIndex = Math.max(0, m.count - m.visible);
    var idx = parseInt(m.track.dataset.index || '0', 10);
    idx = dir === 'prev' ? idx - 1 : idx + 1;
    idx = Math.max(0, Math.min(maxIndex, idx));
    m.track.dataset.index = String(idx);
    updateSlider(wrapper);
  }

  function selectSwatch(card, swatch) {
    var swatches = card.querySelectorAll('.aico-pc__swatch');
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.remove('aico-pc__swatch--active');
    }
    swatch.classList.add('aico-pc__swatch--active');

    var img = card.querySelector('.aico-pc__image');
    var imgUrl = swatch.dataset.imageUrl;
    if (img && imgUrl) {
      img.removeAttribute('srcset');
      img.src = imgUrl;
    }

    var priceWrap = card.querySelector('.aico-pc__price');
    if (priceWrap) {
      var onSale = swatch.dataset.onSale === 'true';
      var price = swatch.dataset.price || '';
      var compareAt = swatch.dataset.compareAtPrice || '';
      var html = '<span class="aico-pc__normal-price' + (onSale ? ' aico-pc__sale-price' : '') + '">' + price + '</span>';
      if (onSale && compareAt) html += '<span class="aico-pc__compare-at-price">' + compareAt + '</span>';
      priceWrap.innerHTML = html;
    }

    var addBtn = card.querySelector('.aico-pc__add-to-cart');
    if (addBtn) {
      var available = swatch.dataset.available === 'true';
      addBtn.disabled = !available;
      addBtn.dataset.variantId = swatch.dataset.variantId;
      var addText = addBtn.dataset.i18nAdd;
      var soldText = addBtn.dataset.i18nSoldout;
      if (addText && soldText) addBtn.textContent = available ? addText : soldText;
    }

    var fav = card.querySelector('favorite-button');
    if (fav) {
      fav.dataset.variantId = swatch.dataset.variantId;
      fav.dataset.price = swatch.dataset.price || '';
      fav.dataset.compareAtPrice = swatch.dataset.onSale === 'true' ? swatch.dataset.compareAtPrice || '' : '';
      if (swatch.dataset.imageUrl) fav.dataset.image = swatch.dataset.imageUrl;
      fav.dataset.available = swatch.dataset.available;
      var vt = swatch.querySelector('.aico-pc__swatch-title');
      if (vt) fav.dataset.variantTitle = vt.textContent.trim();
      if (typeof fav.update === 'function') fav.update();
    }
  }

  function addToCart(btn, variantId) {
    var addText = btn.dataset.i18nAdd || btn.textContent;
    var addingText = btn.dataset.i18nAdding || addText;
    var addedText = btn.dataset.i18nAdded || addText;
    var limitText = btn.dataset.i18nLimit || addText;

    btn.disabled = true;
    btn.textContent = addingText;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (res.status === 422) {
          btn.textContent = limitText;
          setTimeout(function () { btn.textContent = addText; btn.disabled = false; }, 2000);
          return;
        }
        if (!res.ok) throw new Error('add to cart failed');
        document.dispatchEvent(new CustomEvent('cart:update', {
          detail: { data: { itemCount: 1, source: 'product-form-component' } },
        }));
        btn.textContent = addedText;
        setTimeout(function () { btn.textContent = addText; btn.disabled = false; }, 1500);
      })
      .catch(function (err) {
        console.error('[aico-pc] add to cart failed:', err);
        btn.textContent = addText;
        btn.disabled = false;
      });
  }

  // Swipe the variant swatch slider (touch + mouse/pen drag).
  // Suppresses the swatch-select click when the gesture was a real horizontal swipe.
  function wireSwatchSwipe(wrapper, card) {
    var viewport = wrapper.querySelector('.aico-pc__variants-viewport');
    if (!viewport) return;

    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var dragging = false;
    var isHorizontal = false;
    var swiped = false;
    var SWIPE_THRESHOLD = 25; // px needed to trigger a swatch step

    function onStart(x, y) {
      startX = x;
      startY = y;
      deltaX = 0;
      dragging = true;
      isHorizontal = false;
      swiped = false;
    }

    function onMove(x, y, e) {
      if (!dragging) return;
      deltaX = x - startX;
      var deltaY = y - startY;
      if (!isHorizontal && Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10) return;
      if (!isHorizontal) {
        isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
      }
      if (isHorizontal && e && e.cancelable) e.preventDefault();
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;
      if (!isHorizontal) return;
      if (deltaX <= -SWIPE_THRESHOLD) {
        swiped = true;
        shift(wrapper, 'next');
      } else if (deltaX >= SWIPE_THRESHOLD) {
        swiped = true;
        shift(wrapper, 'prev');
      }
    }

    // Touch — stopPropagation so the swipe stays inside the swatch slider
    // and does not also page the outer product carousel.
    viewport.addEventListener('touchstart', function (e) {
      e.stopPropagation();
      var t = e.touches[0];
      onStart(t.clientX, t.clientY);
    }, { passive: true });
    viewport.addEventListener('touchmove', function (e) {
      e.stopPropagation();
      var t = e.touches[0];
      onMove(t.clientX, t.clientY, e);
    }, { passive: false });
    viewport.addEventListener('touchend', function (e) { e.stopPropagation(); onEnd(); });
    viewport.addEventListener('touchcancel', function (e) { e.stopPropagation(); onEnd(); });

    // Pointer (mouse / pen); touch handled above
    if (window.PointerEvent) {
      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        e.stopPropagation();
        onStart(e.clientX, e.clientY);
      });
      viewport.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        e.stopPropagation();
        onMove(e.clientX, e.clientY, e);
      });
      viewport.addEventListener('pointerup', function (e) {
        if (e.pointerType === 'touch') return;
        e.stopPropagation();
        onEnd();
      });
      viewport.addEventListener('pointercancel', function (e) {
        if (e.pointerType === 'touch') return;
        e.stopPropagation();
        onEnd();
      });
    }

    // Cancel the swatch-select click that fires at the end of a drag
    viewport.addEventListener('click', function (e) {
      if (swiped) {
        e.preventDefault();
        e.stopPropagation();
        swiped = false;
      }
    }, true);
  }

  // Recompute sliders on resize / breakpoint change
  var resizeT;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () {
      document.querySelectorAll('aico-product-card').forEach(function (card) {
        var wrapper = card.querySelector('.aico-pc__variants-wrapper');
        if (wrapper) updateSlider(wrapper);
      });
    }, 150);
  });
  if (mqMobile.addEventListener) {
    mqMobile.addEventListener('change', function () {
      document.querySelectorAll('aico-product-card').forEach(function (card) {
        var wrapper = card.querySelector('.aico-pc__variants-wrapper');
        if (wrapper) updateSlider(wrapper);
      });
    });
  } else if (mqMobile.addListener) {
    mqMobile.addListener(function () {
      document.querySelectorAll('aico-product-card').forEach(function (card) {
        var wrapper = card.querySelector('.aico-pc__variants-wrapper');
        if (wrapper) updateSlider(wrapper);
      });
    });
  }

  class AicoProductCard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.aicoPcWired === '1') return;
      this.dataset.aicoPcWired = '1';

      var card = this;
      var wrapper = card.querySelector('.aico-pc__variants-wrapper');
      if (wrapper) {
        updateSlider(wrapper);
        wrapper.addEventListener('click', function (e) {
          var btn = e.target.closest('.aico-pc__variants-btn');
          if (!btn) return;
          shift(wrapper, btn.classList.contains('aico-pc__variants-previous-btn') ? 'prev' : 'next');
        });
        wireSwatchSwipe(wrapper, card);
      }

      card.addEventListener('click', function (e) {
        var swatch = e.target.closest('.aico-pc__swatch');
        if (swatch) { selectSwatch(card, swatch); return; }
        var addBtn = e.target.closest('.aico-pc__add-to-cart');
        if (addBtn && !addBtn.disabled) {
          e.preventDefault();
          var active = card.querySelector('.aico-pc__swatch--active');
          var variantId = (active && active.dataset.variantId) || addBtn.dataset.variantId;
          if (variantId) addToCart(addBtn, variantId);
        }
      });
    }
  }

  if (!customElements.get('aico-product-card')) {
    customElements.define('aico-product-card', AicoProductCard);
  }
})();
